import axiosIns from '@/libs/axios'
import { parseManagerIds } from '@/auth/taskPermissions'

// Form çoklu seçimleri id listesi bekler; BE yöneticiyi tekil de döndürebilir, gözlemciyi kayıt listesi olarak verir.
export const toWatcherForm = row => {
  const watchers = Array.isArray(row.watchers) ? row.watchers : []
  return {
    ...row,
    is_public: Number(row.is_public ?? 1),
    id_manager_users: parseManagerIds(row.id_manager_users),
    watcher_users: watchers.filter(w => w.watcher_type === 'user').map(w => Number(w.id_user)).filter(Boolean),
    watcher_teams: watchers.filter(w => w.watcher_type === 'team').map(w => Number(w.id_team)).filter(Boolean),
  }
}

// Seçimi gözlemci kayıtlarıyla eşitler; başarısızsa false döner, ana kayıt geçerli kalır.
export const syncWatchers = async (url, parentKey, parentId, { watchers, watcher_users: users, watcher_teams: teams }) => {
  const existing = Array.isArray(watchers) ? watchers : []
  const has = (type, id) => existing.some(w => w.watcher_type === type
    && Number(type === 'user' ? w.id_user : w.id_team) === id)
  const removed = existing.filter(w => (w.watcher_type === 'user'
    ? !users.includes(Number(w.id_user))
    : !teams.includes(Number(w.id_team))))
  const requests = [
    ...users.filter(id => !has('user', id)).map(id => ({ watcher_type: 'user', id_watcher_users: id })),
    ...teams.filter(id => !has('team', id)).map(id => ({ watcher_type: 'team', id_watcher_teams: id })),
  ].map(item => axiosIns.post(`${url}/saveData`, { ...item, [parentKey]: parentId }))
  requests.push(...removed.map(w => axiosIns.post(`${url}/deleteData`, { id: w.id })))
  try {
    const results = await Promise.all(requests)
    return results.every(res => res.data?.status)
  } catch (e) {
    return false
  }
}
